export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <p>
        © {new Date().getFullYear()} Goodwing Solutions ·{' '}
        <a href="https://goodwingsolutions.com" target="_blank" rel="noopener noreferrer">
          goodwingsolutions.com
        </a>
      </p>
    </footer>
  );
}
